// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*-----DRAWER---- NAVBAR---*/
 
#appbar {
  background-color: #1976d2;
}
 
 `, "",{"version":3,"sources":["webpack://./src/components/navbars/Navbar.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,yBAAyB;AAC3B","sourcesContent":["/*-----DRAWER---- NAVBAR---*/\r\n \r\n#appbar {\r\n  background-color: #1976d2;\r\n}\r\n \r\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
